import { render, staticRenderFns } from "./ReportStatistics.vue?vue&type=template&id=34b264ea&"
import script from "./ReportStatistics.vue?vue&type=script&lang=js&"
export * from "./ReportStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports